export var ACTIVAR = 'MASCARAS_ACTIVAR';
export var activar = function activar() {
  return {
    type: ACTIVAR
  };
};
export var DESACTIVAR = 'MASCARAS_DESACTIVAR';
export var desactivar = function desactivar() {
  return {
    type: DESACTIVAR
  };
};
export var MOSTRAR = 'MASCARAS_MOSTRAR';
export var mostrar = function mostrar() {
  return {
    type: MOSTRAR
  };
};
export var OCULTAR = 'MASCARAS_OCULTAR';
export var ocultar = function ocultar() {
  return {
    type: OCULTAR
  };
};
export var RESETEAR = 'MASCARAS_RESETEAR';
export var resetear = function resetear() {
  return {
    type: RESETEAR
  };
};
export var CREAR_PANEL = 'MASCARAS_CREAR_PANEL';
export var crearPanel = function crearPanel(x, y, w, h) {
  return {
    type: CREAR_PANEL,
    x: x,
    y: y,
    w: w,
    h: h
  };
};
export var MOVER_PANEL = 'MASCARAS_MOVER_PANEL';
export var moverPanel = function moverPanel(id, x, y, w, h) {
  return {
    type: MOVER_PANEL,
    id: id,
    x: x,
    y: y,
    w: w,
    h: h
  };
};
export var ELIMINAR_PANEL = 'MASCARAS_ELIMINAR_PANEL';
export var eliminarPanel = function eliminarPanel(id) {
  return {
    type: ELIMINAR_PANEL,
    id: id
  };
};